// extracted by mini-css-extract-plugin
module.exports = {"contentTagEditor":"ContentTagEditor_contentTagEditor__T-0j6"};